import { useParams } from "react-router-dom"
import { Container, Row, Col } from "react-bootstrap"
import { useGetPropertyAmenityByIdQuery } from "../../../services/bClientApi"
import PropertyAmenityEntry from "../../../Components/PropertyAmenity/PropertyAmenityEntry/PropertyAmenityEntry"
import DataLogList from "../../../Components/DataLogs/DataLogList"

export default function PropertyAmenityPage() {
    const { propertyAmenityId = '' } = useParams()

    const {
        data,
        error,
        isLoading
    } = useGetPropertyAmenityByIdQuery(propertyAmenityId, { skip: !propertyAmenityId })
    const propertyAmenityData = data || {}

    return (
        <Container>
            <Row>
                <Col
                    xs={12}
                    lg={9}
                >
                    <h1>Property Amenity Details</h1>
                    <hr />
                    {error && (<>{JSON.stringify(error)}<br /></>)}

                    {propertyAmenityId && propertyAmenityData && propertyAmenityData._id && !isLoading && (
                        <PropertyAmenityEntry
                            propertyAmenityData={propertyAmenityData}
                            fullView={true}
                        />
                    )}
                </Col>

                <Col
                    xs={12}
                    lg={3}
                >
                    <DataLogList
                        dataType="propertyAmenity"
                        dataId={propertyAmenityId}
                    />
                </Col>
            </Row>
        </Container>
    )
}
